import * as _ from "lodash";
import { IApplication } from "../interfaces/application";
import * as Constants from "./constants";
import * as Global from "./global";

// callWebService
// does an async call to a web service
// returns the promise object from the $.ajax call
// url : the url of the web service to call
// request : the data in JSON format to pass into the parameters of the web service
export function callWebService(
    url: string,
    type: string,
    request?: any,
    showMessageOnError?: boolean): JQuery.Deferred<any, any, any> {

    let data: any;
    let headers: any;
    const app: IApplication = Global.app();
    const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

    if (request != null) {
        data = JSON.stringify(request);
    }

    if (app.userSession != null && app.authenticationToken != null) {
        // used has logged in, so pass the token in the header of every request
        headers = { Authorization: "token " + app.authenticationToken };
    }
    $.ajax({
        type,
        url: app.webServiceBaseURL + url,
        data,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        headers,
        success(result: any): void {
            if (result.RotateAuthenticationToken) {
                // need to start using a new token
                app.setAuthenticationToken(result.AuthenticationToken);
            }
            deferred.resolve(result);
        },
        error(theXhr: JQueryXHR, status: string, error: string): void {
            deferred.reject(theXhr, status, error);
        },
    });

    if (showMessageOnError == null ||
        showMessageOnError === true) {
        // add a default handler for fails that shows an error message dialog
        deferred.fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            handleAjaxError(jqXHR);
        });
    }
    return deferred;
}

export function callReportService(
    url: string,
    type: string,
    request: any): JQuery.Deferred<any, any, any> {

    let data: any;
    const app: IApplication = Global.app();
    const headers = { Authorization: "Bearer " + app.reportToken };
    const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

    if (request != null) {
        data = JSON.stringify(request);
    }

    $.ajax({
        type,
        url: app.reportingWebServiceBaseURL + url,
        data,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        headers,
        success(result: any): void {
            deferred.resolve(result);
        },
        error(theXhr: JQueryXHR, status: string, error: string): void {
            deferred.reject(theXhr, status, error);
        },
    });

    return deferred;
}

// handle when a web service call returns an error.
export function handleAjaxError(jqXHR: JQueryXHR): void {
    let authenticateHeader: string | null;

    if (jqXHR.status === Constants.HTTP_STATUS_UNAUTHORIZED) {
        authenticateHeader = jqXHR.getResponseHeader("WWW-Authenticate");
        if (authenticateHeader == null || authenticateHeader === "") {
            // user is logged in, but does not have access to run the requested function
            Global.app().showErrorMessage([Constants.PHRASE_UNAUTHORIZEDACCESS]);
        } else {
            // user is not logged in, or session has expired
            // send user back to login page
            window.location.href = "/";
        }
    } else {
        // request failed for some reason other than authorization
        Global.app().showErrorMessage([Constants.PHRASE_GENERALACTIONFAILURE]);
    }
}

export function getURLParameter(sParam: string): string {
    const sPageURL: string = window.location.search.substring(1);
    const sURLVariables: string[] = sPageURL.split("&");

    for (const urlVar of sURLVariables) {
        const sParameterName: string[] = urlVar.split("=");
        if (sParameterName[0] === sParam) {
            return sParameterName[1];
        }
    }

    return "";
}

export interface IKeyValuePair {
    Key: string;
    Value: string;
}

export function getURLParameters(): IKeyValuePair[] {
    const params: IKeyValuePair[] = [];
    const url: string = window.location.search.substring(1);
    const qsValues: string[] = url.split("&");

    for (const qsValue of qsValues) {
        const qsSplit: string[] = qsValue.split("=");
        params.push({Key: qsSplit[0], Value: qsSplit[1] });
    }
    return params;
}

export function getURLNumberParameter(sParam: string): number | null {
    const value: string = getURLParameter(sParam);
    if (value === "" || isNaN(Number(value))) {
        return null;
    } else {
        return Number(value);
    }
}

// returns true if the value is undefined, null or and empty string
export function isNullOrEmpty(value: any): boolean {
    return _.isUndefined(value) || value === null || _.isEmpty(value);
}
export function isNullOrSpace(value: any): boolean {
    return _.isUndefined(value) || value === null || _.isEmpty(value) || value.trim().length === 0;
}

export function setCookie(cname: string, cvalue: string): void {
    const app: IApplication = Global.app();

    if (app.webServiceBaseDomain === "localhost") {
        // for localhost, do not use a domain
        document.cookie = cname + "=" + cvalue + ";path=/;";
    } else {
        // set a domain so cookie gets passed for request to both the web site and the server
        // The "SameSite" property is being set to "None" to support hosting
        // OnCue in an iframe, like Advantage VSS.
        document.cookie = cname + "=" + cvalue + ";path=/;domain=." + app.webServiceBaseDomain + "; SameSite=None; Secure;";
    }
}

export function getCookie(cname: string): string {
    const name: string = cname + "=";
    const ca: string[] = document.cookie.split(";");

    for (let c of ca) {
        while (c.charAt(0) === " ") { c = c.substring(1); }
        if (c.indexOf(name) === 0) { return c.substring(name.length, c.length); }
    }

    return "";
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/util.ts